import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  COLOR_FFF,
  PLEASE_WAIT_MESSAGE,
} from "../../../utils/constants/GlobalConstants";

export default function SimpleBackdrop(props) {
  const [open, setOpen] = React.useState(props.open);
  const [message, setMessage] = React.useState(props.messageShow);

  React.useEffect(() => {
    setOpen(props.open);
    if (props?.messageShow) {
      setMessage(props?.messageShow);
    }
  }, [props]);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Backdrop
        sx={(theme) => ({ ...COLOR_FFF, zIndex: theme.zIndex.drawer + 1 })}
        open={open}
        onClick={handleClose}
        style={{ display: "flex" }}
        testid={"backdrop"}
      >
        <CircularProgress color="inherit" />
        {message && (
          <>
            &nbsp; &nbsp; <div>{PLEASE_WAIT_MESSAGE}</div>
          </>
        )}
      </Backdrop>
    </div>
  );
}
